// // JobApplicationForm.jsx
// import React, { useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";

// const ADD_API =
//   "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_application";

// export default function JobApplicationForm() {
//   const initial = {
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     gender: "",
//     email: "",
//     country_code: "+91",
//     mobile_phone: "",
//     experience_years: "",
//     experience_months: "",
//     current_salary: "",
//     current_salary_currency: "INR",
//     expected_salary: "",
//     available_to_join_days: "",
//     current_location: "",
//     current_company: "",
//     linkedin_url: "",
//     job_role: "",
//     resume_file: null,

//     // Experience details (merged from Details.js)
//     companyName: "",
//     jobTitle: "",
//     currentlyWorking: false,
//     dateOfJoining: "",
//     dateOfRelieving: "",
//     experience_location: "",
//   };

//   const [formData, setFormData] = useState(initial);
//   const [resumeName, setResumeName] = useState("");
//   const [error, setError] = useState(null);
//   const [successMsg, setSuccessMsg] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [showExperienceForm, setShowExperienceForm] = useState(false);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files && e.target.files[0];
//     if (file) {
//       setFormData((prev) => ({ ...prev, resume_file: file }));
//       setResumeName(file.name);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setSuccessMsg("");

//     if (!formData.first_name || !formData.last_name || !formData.email) {
//       setError("Please fill all required fields.");
//       return;
//     }

//     try {
//       setSubmitting(true);
//       const payload = new FormData();

//       // Map frontend field names to backend expected keys
//       Object.entries(formData).forEach(([key, val]) => {
//         if (val !== null && val !== "") {
//           switch (key) {
//             case "companyName":
//               payload.append("current_company", val);
//               break;
//             case "jobTitle":
//               payload.append("job_role", val);
//               break;
//             case "currentlyWorking":
//               payload.append("currently_working", val ? 1 : 0);
//               break;
//             case "dateOfJoining":
//               payload.append("date_of_joining", val);
//               break;
//             case "dateOfRelieving":
//               payload.append("date_of_relieving", val);
//               break;
//             case "experience_location":
//               payload.append("experience_location", val);
//               break;
//             default:
//               payload.append(key, val);
//           }
//         }
//       });

//       const res = await axios.post(ADD_API, payload, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data?.status) {
//         setSuccessMsg(res.data.message || "Application submitted successfully.");
//         setFormData(initial);
//         setResumeName("");
//       } else {
//         setError(res.data?.message || "Submission failed");
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || "Network error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="container-fluid mt-5 form3-top pb-5">
//       <Link to="/back">
//         <i className="fa-solid fa-arrow-left-long"></i> Back to all job opening
//       </Link>

//       <div className="container box35">
//         <h1>Apply for this jobs</h1>
//         <div className="box34">
//           <label htmlFor="resumeUpload" style={{ cursor: "pointer" }}>
//             Upload resume
//           </label>
//           <input
//             id="resumeUpload"
//             type="file"
//             accept=".pdf,.doc,.docx"
//             onChange={handleFileChange}
//             style={{ display: "none" }}
//           />
//           <br />
//           <small>This will auto-fill the fields below. 10MB max file size</small>
//           {resumeName && (
//             <div className="mt-2">
//               <strong>Selected:</strong> {resumeName}
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="container mt-3">
//         <form onSubmit={handleSubmit}>
//           {/* --- Personal Info --- */}
//           <div className="row mb-3 box32">
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>First Name*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="first_name"
//                 value={formData.first_name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Middle Name</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="middle_name"
//                 value={formData.middle_name}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Last Name*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="last_name"
//                 value={formData.last_name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>

//           {/* Gender, Email, Job Role */}
//           <div className="row mb-3">
//             <div className="col-md-4">
//               <small>Gender*</small>
//               <select
//                 className="form-control"
//                 name="gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Select an option</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//             <div className="col-md-4">
//               <small>Email*</small>
//               <input
//                 type="email"
//                 className="form-control"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-md-4">
//               <small>Job Role</small>
//               <select
//                 className="form-control"
//                 name="job_role"
//                 value={formData.job_role}
//                 onChange={handleChange}
//               >
//                 <option value="">Select an option</option>
//                 <option value="Procurement">Procurement Executive</option>
//                 <option value="Interior">Interior Designer</option>
//                 <option value="Project">Project Manager – Turnkey Solutions</option>
//               </select>
//             </div>
//           </div>

//           {/* Mobile + Experience + Salary */}
//           <div className="row mb-3">
//             <div className="col-md-4">
//               <label>Mobile Phone</label>
//               <div className="input-group">
//                 <select
//                   className="form-control countryCode"
//                   name="country_code"
//                   value={formData.country_code}
//                   onChange={handleChange}
//                 >
//                   <option value="+91">+91</option>
//                   <option value="+1">+1</option>
//                   <option value="+44">+44</option>
//                 </select>
//                 <input
//                   type="tel"
//                   className="form-control"
//                   name="mobile_phone"
//                   value={formData.mobile_phone}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
//             <div className="col-md-2">
//               <small>Experience (Years)</small>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="experience_years"
//                 value={formData.experience_years}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="col-md-2">
//               <small>Experience (Months)</small>
//               <select
//                 className="form-control"
//                 name="experience_months"
//                 value={formData.experience_months}
//                 onChange={handleChange}
//               >
//                 <option value="">Months</option>
//                 {Array.from({ length: 12 }).map((_, i) => (
//                   <option key={i} value={i}>
//                     {i}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="col-md-4">
//               <small>Current Salary*</small>
//               <div className="input-group">
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="current_salary"
//                   value={formData.current_salary}
//                   onChange={handleChange}
//                 />
//                 <select
//                   className="form-control"
//                   name="current_salary_currency"
//                   value={formData.current_salary_currency}
//                   onChange={handleChange}
//                 >
//                   <option value="INR">INR</option>
//                   <option value="USD">USD</option>
//                   <option value="EUR">EUR</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Expected Salary, Available Days, Location */}
//           <div className="row mb-3">
//             <div className="col-md-4">
//               <small>Expected Salary*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="expected_salary"
//                 value={formData.expected_salary}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="col-md-4">
//               <small>Available To Join (days)*</small>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="available_to_join_days"
//                 value={formData.available_to_join_days}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="col-md-4">
//               <small>Current Location*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="current_location"
//                 value={formData.current_location}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="col-md-4">
//               <small>LinkedIn URL*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="linkedin_url"
//                 value={formData.linkedin_url}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           {/* ------- Experience Button ------- */}
//         <button
//           type="button"
//           className="btn btn-primary mb-3"
//           onClick={() => setShowExperienceForm(!showExperienceForm)}
//         >
//           {showExperienceForm ? "Hide Experience Details" : "+ Add Experience Details"}
//         </button>

//         {/* ------- Experience Details (toggle) ------- */}
//         {showExperienceForm && (
//           <>
//             <h4 className="mt-4">Experience Details</h4>
//           <div className="row mb-3">
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Company Name*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="companyName"
//                 value={formData.companyName}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Job Title*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="jobTitle"
//                 value={formData.jobTitle}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-check mt-4 ms-2">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="currentlyWorking"
//                 name="currentlyWorking"
//                 checked={formData.currentlyWorking}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label" htmlFor="currentlyWorking">
//                 <small>Currently working here</small>
//               </label>
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Date of Joining*</small>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="dateOfJoining"
//                 value={formData.dateOfJoining}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Date of Relieving*</small>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="dateOfRelieving"
//                 value={formData.dateOfRelieving}
//                 onChange={handleChange}
//                 required={!formData.currentlyWorking}
//               />
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-12">
//               <small>Location*</small>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="experience_location"
//                 value={formData.experience_location}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>
//           </>
//         )}

//           {/* --- Messages --- */}
//           {error && <div className="alert alert-danger">{error}</div>}
//           {successMsg && <div className="alert alert-success">{successMsg}</div>}

//           {/* --- Submit Button --- */}
//           <div className="mt-3 mb-5 text-center">
//             <button className="btn btn-primary" type="submit" disabled={submitting}>
//               {submitting ? "Submitting..." : "Submit Application"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }


// JobApplicationForm.jsx
import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const ADD_API =
  "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_application";

export default function JobApplicationForm() {
  const initial = {
    first_name: "",
    middle_name: "",
    last_name: "",
    gender: "",
    email: "",
    country_code: "+91",
    mobile_phone: "",
    experience_years: "",
    experience_months: "",
    current_salary: "",
    current_salary_currency: "INR",
    expected_salary: "",
    available_to_join_days: "",
    current_location: "",
    current_company: "",
    linkedin_url: "",
    job_role: "",
    resume_file: null,
    companyName: "",
    jobTitle: "",
    currentlyWorking: false,
    dateOfJoining: "",
    dateOfRelieving: "",
    experience_location: "",
  };

  const [formData, setFormData] = useState(initial);
  const [resumeName, setResumeName] = useState("");
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showExperienceForm, setShowExperienceForm] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, resume_file: file }));
      setResumeName(file.name);
    }
  };

  const sendEmailNotification = () => {
    const subject = `New Job Application - ${formData.job_role || "Position"}`;
    
    const body = `
NEW JOB APPLICATION RECEIVED

═══════════════════════════════════════
PERSONAL INFORMATION
═══════════════════════════════════════
Name: ${formData.first_name} ${formData.middle_name} ${formData.last_name}
Gender: ${formData.gender}
Email: ${formData.email}
Phone: ${formData.country_code} ${formData.mobile_phone}

═══════════════════════════════════════
JOB DETAILS
═══════════════════════════════════════
Applied For: ${formData.job_role || "Not specified"}
Current Location: ${formData.current_location}

═══════════════════════════════════════
EXPERIENCE
═══════════════════════════════════════
Total Experience: ${formData.experience_years || 0} Years ${formData.experience_months || 0} Months
${formData.companyName ? `Current Company: ${formData.companyName}` : ''}
${formData.jobTitle ? `Current Position: ${formData.jobTitle}` : ''}
${formData.experience_location ? `Work Location: ${formData.experience_location}` : ''}
${formData.dateOfJoining ? `Date of Joining: ${formData.dateOfJoining}` : ''}
${formData.currentlyWorking ? 'Currently Working: Yes' : formData.dateOfRelieving ? `Date of Relieving: ${formData.dateOfRelieving}` : ''}

═══════════════════════════════════════
SALARY INFORMATION
═══════════════════════════════════════
Current Salary: ${formData.current_salary} ${formData.current_salary_currency}
Expected Salary: ${formData.expected_salary}

═══════════════════════════════════════
AVAILABILITY
═══════════════════════════════════════
Available to Join: ${formData.available_to_join_days} days

═══════════════════════════════════════
ADDITIONAL INFORMATION
═══════════════════════════════════════
LinkedIn: ${formData.linkedin_url || "Not provided"}
Resume: ${resumeName || "Not uploaded"}

═══════════════════════════════════════
Application submitted on: ${new Date().toLocaleString()}
    `;

    // Create mailto link
    const mailtoLink = `mailto:info@nlfs.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMsg("");

    if (!formData.first_name || !formData.last_name || !formData.email) {
      setError("Please fill all required fields.");
      return;
    }

    try {
      setSubmitting(true);
      const payload = new FormData();

      // Map frontend field names to backend expected keys
      Object.entries(formData).forEach(([key, val]) => {
        if (val !== null && val !== "") {
          switch (key) {
            case "companyName":
              payload.append("current_company", val);
              break;
            case "jobTitle":
              payload.append("job_role", val);
              break;
            case "currentlyWorking":
              payload.append("currently_working", val ? 1 : 0);
              break;
            case "dateOfJoining":
              payload.append("date_of_joining", val);
              break;
            case "dateOfRelieving":
              payload.append("date_of_relieving", val);
              break;
            case "experience_location":
              payload.append("experience_location", val);
              break;
            default:
              payload.append(key, val);
          }
        }
      });

      const res = await axios.post(ADD_API, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data?.status) {
        // Send email notification after successful form submission
        sendEmailNotification();
        
        setSuccessMsg(
          res.data.message || 
          "Application submitted successfully! Email client opened for notification."
        );
        setFormData(initial);
        setResumeName("");
        setShowExperienceForm(false);
      } else {
        setError(res.data?.message || "Submission failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Network error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid mt-5 form3-top pb-5">
      <Link to="/back">
        <i className="fa-solid fa-arrow-left-long"></i> Back to all job opening
      </Link>

      <div className="container box35">
        <h1>Apply for this jobs</h1>
        <div className="box34">
          <label htmlFor="resumeUpload" style={{ cursor: "pointer" }}>
            Upload resume
          </label>
          <input
            id="resumeUpload"
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <br />
          <small>This will auto-fill the fields below. 10MB max file size</small>
          {resumeName && (
            <div className="mt-2">
              <strong>Selected:</strong> {resumeName}
            </div>
          )}
        </div>
      </div>

      <div className="container mt-3">
        <form onSubmit={handleSubmit}>
          {/* --- Personal Info --- */}
          <div className="row mb-3 box32">
            <div className="col-lg-4 col-md-4 col-sm-12">
              <small>First Name*</small>
              <input
                type="text"
                className="form-control"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <small>Middle Name</small>
              <input
                type="text"
                className="form-control"
                name="middle_name"
                value={formData.middle_name}
                onChange={handleChange}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <small>Last Name*</small>
              <input
                type="text"
                className="form-control"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Gender, Email, Job Role */}
          <div className="row mb-3">
            <div className="col-md-4">
              <small>Gender*</small>
              <select
                className="form-control"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select an option</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col-md-4">
              <small>Email*</small>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <small>Job Role</small>
              <select
                className="form-control"
                name="job_role"
                value={formData.job_role}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="Procurement">Procurement Executive</option>
                <option value="Interior">Interior Designer</option>
                <option value="Project">Project Manager – Turnkey Solutions</option>
              </select>
            </div>
          </div>

          {/* Mobile + Experience + Salary */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label>Mobile Phone</label>
              <div className="input-group">
                <select
                  className="form-control countryCode"
                  name="country_code"
                  value={formData.country_code}
                  onChange={handleChange}
                >
                  <option value="+91">+91</option>
                  <option value="+1">+1</option>
                  <option value="+44">+44</option>
                </select>
                <input
                  type="tel"
                  className="form-control"
                  name="mobile_phone"
                  value={formData.mobile_phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-2">
              <small>Experience (Years)</small>
              <input
                type="number"
                className="form-control"
                name="experience_years"
                value={formData.experience_years}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-2">
              <small>Experience (Months)</small>
              <select
                className="form-control"
                name="experience_months"
                value={formData.experience_months}
                onChange={handleChange}
              >
                <option value="">Months</option>
                {Array.from({ length: 12 }).map((_, i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <small>Current Salary*</small>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  name="current_salary"
                  value={formData.current_salary}
                  onChange={handleChange}
                />
                <select
                  className="form-control"
                  name="current_salary_currency"
                  value={formData.current_salary_currency}
                  onChange={handleChange}
                >
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
            </div>
          </div>

          {/* Expected Salary, Available Days, Location */}
          <div className="row mb-3">
            <div className="col-md-4">
              <small>Expected Salary*</small>
              <input
                type="text"
                className="form-control"
                name="expected_salary"
                value={formData.expected_salary}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <small>Available To Join (days)*</small>
              <input
                type="number"
                className="form-control"
                name="available_to_join_days"
                value={formData.available_to_join_days}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <small>Current Location*</small>
              <input
                type="text"
                className="form-control"
                name="current_location"
                value={formData.current_location}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <small>LinkedIn URL*</small>
              <input
                type="text"
                className="form-control"
                name="linkedin_url"
                value={formData.linkedin_url}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ------- Experience Button ------- */}
          <button
            type="button"
            className="btn btn-primary mb-3"
            onClick={() => setShowExperienceForm(!showExperienceForm)}
          >
            {showExperienceForm ? "Hide Experience Details" : "+ Add Experience Details"}
          </button>

          {/* ------- Experience Details (toggle) ------- */}
          {showExperienceForm && (
            <>
              <h4 className="mt-4">Experience Details</h4>
              <div className="row mb-3">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <small>Company Name*</small>
                  <input
                    type="text"
                    className="form-control"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <small>Job Title*</small>
                  <input
                    type="text"
                    className="form-control"
                    name="jobTitle"
                    value={formData.jobTitle}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-check mt-4 ms-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="currentlyWorking"
                    name="currentlyWorking"
                    checked={formData.currentlyWorking}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="currentlyWorking">
                    <small>Currently working here</small>
                  </label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <small>Date of Joining*</small>
                  <input
                    type="date"
                    className="form-control"
                    name="dateOfJoining"
                    value={formData.dateOfJoining}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <small>Date of Relieving*</small>
                  <input
                    type="date"
                    className="form-control"
                    name="dateOfRelieving"
                    value={formData.dateOfRelieving}
                    onChange={handleChange}
                    required={!formData.currentlyWorking}
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <small>Location*</small>
                  <input
                    type="text"
                    className="form-control"
                    name="experience_location"
                    value={formData.experience_location}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </>
          )}

          {/* --- Messages --- */}
          {error && <div className="alert alert-danger">{error}</div>}
          {successMsg && <div className="alert alert-success">{successMsg}</div>}

          {/* --- Submit Button --- */}
          <div className="mt-3 mb-5 text-center">
            <button className="btn btn-primary" type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit Application"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}